export default [
    {
        name: 'Waitpay',
        path: 'Waitpay',
        component: () => import('@/pages/BigData/Bill/Waitpay'),
        meta: { title: '待支付' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'Areadypay',
        path: 'Areadypay',
        component: () => import('@/pages/BigData/Bill/Areadypay'),
        meta: { title: '已支付' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'SettlementDetails',
        path: 'SettlementDetails',
        redirect:{name:'sAllDetails'},
        component: () => import('@/pages/BigData/Bill/SettlementDetails'),
        meta: { title: '结算明细' },
        props(route) {
            return {
                id: route.query.id
            }
        },
        children: [
            {
                name: 'sAllDetails',
                path: 'sAllDetails',
                component: () => import('@/pages/BigData/Bill/SettlementDetails/sAllDetails'),
                meta: { title: '全部' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
            {
                name: 'sSettlingDetails',
                path: 'sSettlingDetails',
                component: () => import('@/pages/BigData/Bill/SettlementDetails/sSettlingDetails'),
                meta: { title: '结算中' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
            {
                name: 'sGeneratedDetails',
                path: 'sGeneratedDetails',
                component: () => import('@/pages/BigData/Bill/SettlementDetails/sGeneratedDetails'),
                meta: { title: '已生成账单' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            },
            {
                name: 'sPaidDetails',
                path: 'sPaidDetails',
                component: () => import('@/pages/BigData/Bill/SettlementDetails/sPaidDetails'),
                meta: { title: '已支付' },
                props(route) {
                    return {
                        id: route.query.id
                    }
                },
            }
        ]
    },
]